import React from 'react';
import classNames from 'classnames';
import Link from 'next/link';
import { twMerge } from 'tailwind-merge';

export interface CardProps {
  className?: string;
  children?: React.ReactNode;
  onClick?: () => void;
  to?: string;
}

export const Card: React.FC<CardProps> = ({ className, children, onClick, to }) => {
  const containerClasses = twMerge(
    classNames(
      'rounded-ds-6 block shadow-ds-bg-card-surface bg-ds-bg-card-surface',
      {
        'transition-all duration-300 ease-in-out': onClick || to,
        'hover:shadow-ds-bg-card-surface-hover hover:border-ds-border-card hover:bg-ds-bg-card-surface-hover hover:cursor-pointer hover:scale-102':
          onClick || to,
        'active:shadow-ds-bg-card-surface-pressed active:border-ds-border-card active:bg-ds-bg-card-surface-pressed active:cursor-pointer':
          onClick || to,
      },
      className,
    ),
  );

  if (to) {
    return (
      <Link href={to} className={containerClasses}>
        {children}
      </Link>
    );
  }

  return (
    <div onClick={onClick} className={containerClasses}>
      {children}
    </div>
  );
};
